import { generateWatermark } from 'lanhu-watermark';

let watermark;
export function _initWatermark(user) {
  if (watermark) {
    return watermark;
  }

  watermark = generateWatermark({
    name: user ? user.name : null || localStorage.getItem('name') || '',
    nickName: user ? user.nickname : null || localStorage.getItem('nickname') || '',
    mobile: user ? user.mobile : null || localStorage.getItem('mobile') || '',
    email: user ? user.email : null || localStorage.getItem('email') || '',
  });
  return watermark;
}

export async function initWatermark(_tid) {
  const tid = _tid || localStorage.teamId;
  const res = await API.project.getPublicPermissions(tid);
  if (!res) {
    return;
  }
  try {
    const isWatermarkOn = res.data && res.data.operations && res.data.operations.includes('switch:watermark');
    if (isWatermarkOn) {
      _initWatermark().generate();
    }
  } catch (e) {
    console.error(e);
  }
}
